
// Function to retrieve reviews from local storage
// if not expired else remove reviews if its expired
function getLoalStorageReviews() {
    const data = localStorage.getItem('submittedReviews');
    if (data){
        const dataWithTimestamp = JSON.parse(data);
        const currentTime = new Date().getTime();
        // is expired if its more than 1 day.
        const isExpired = (currentTime - dataWithTimestamp.timestamp) > (24 * 60 * 60 * 1000);
        if (isExpired){
            // clear expired data from local storage.
            localStorage.removeItem('submittedReviews');
            return [];
        }else {
            return dataWithTimestamp.reviews;
        }
    }else {
        return [];
    }
    
}


// Function to save reviews data into local storage with current timestamp (later, used for checking exipiration time).
function saveReviewsWithTimeStamp(reviews) {
    const dataWithTimeStamp = {
        reviews: reviews,
        timestamp: new Date().getTime() //current timestamp in milliseconds.
    }
    localStorage.setItem('submittedReviews', JSON.stringify(dataWithTimeStamp))
}


// function to add a new review
function addReviewToLocalStorage(review){
    let reviews = getLoalStorageReviews();
    const reviewExists = reviews.some(existingReview => 
        existingReview.actualProductID === review.actualProductID &&
        existingReview.actualCustomerID === review.actualCustomerID &&
        existingReview.customerEmail === review.customerEmail
    );
    // If the review already exists, do not add it again (case, where customer already reviewed the same product.)
    if (reviewExists) {
        console.log('Review already exists. Not adding to local storage.');
        return;
    }

    reviews.push(review);
    saveReviewsWithTimeStamp(reviews)
}



function removeReviewFromLocalStorage(reviewID){
    let reviews = getLoalStorageReviews();
    const updatedReviews = reviews.filter(review => review.id !== reviewID); // filter out the review to be removed.
    saveReviewsWithTimeStamp(updatedReviews)
}
